/* eslint-disable @typescript-eslint/no-explicit-any */
import type { JSX } from 'react';

import styled from 'styled-components';

import { withStore } from '../../store';

const Wrapper = styled.div`
  padding: 10px;
`;

const Card = styled.div`
  background-color: var(--white);
  margin: 0 auto;
  z-index: 202;
  max-width: 550px;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 700px) {
    max-width: 675px;
  }

  @media only screen and (max-width: 600px) {
    max-width: 575px;
  }

  @media only screen and (max-width: 500px) {
    max-width: 475px;
  }

  @media only screen and (max-width: 400px) {
    max-width: 375px;
  }

  @media only screen and (max-width: 300px) {
    min-width: 275px;
  }
`;

const Iframe = styled.iframe`
  border: none;
  width: 100%;
  height: 470px;

  @media only screen and (max-height: 700px) {
    max-height: 350px;
  }

  @media only screen and (max-height: 600px) {
    max-height: 200px;
  }

  @media only screen and (max-height: 500px) {
    max-height: 475px;
  }

  @media only screen and (max-height: 400px) {
    max-height: 375px;
  }

  @media only screen and (max-height: 300px) {
    max-height: 275px;
  }
`;

interface SurveyProps {
  store: any;
}


function Survey({ store }: SurveyProps): JSX.Element {
  const userEmail = store.customer.contactPersonEmail;
  const region = store.customer.region;

  const surveyURL = `https://cargillfeedback.co1.qualtrics.com/jfe/form/SV_551ZGaO77jsjFpH?Email=${userEmail}&Region=${region}`;

  return (
    <Wrapper>
      <Card>
        <Iframe
          title="Redcarpet Survey"
          src={surveyURL}
        />
      </Card>
    </Wrapper>
  );
}

export default withStore(Survey);